import { BaseModel, RecursivePartial } from "@models/base";
import { VzParamOldTriggerAction } from "./param-trigger-action";

export enum VzParamOldTriggerType {
    Manual           = 0,
    ValueChange      = 1,
    EnterKeyPressed  = 2,
}

export enum VzParamOldTriggerCondition {
    None            = 0,
    Equal           = 1,
    NotEqual        = 2,
    Contains        = 3,
    NotContains     = 4,
}

export class VzParamOldTrigger extends BaseModel {
    static Type = VzParamOldTriggerType;
    static Condition = VzParamOldTriggerCondition;

    type!: VzParamOldTriggerType;
    condition?: VzParamOldTriggerCondition = VzParamOldTriggerCondition.None;
    value?: any;
    actions: VzParamOldTriggerAction[] = [];

    constructor(json?: RecursivePartial<VzParamOldTrigger>) {
        super(json);
        this.parseUnreadCounters(json || {});
    }

    parse(json: RecursivePartial<VzParamOldTrigger>): VzParamOldTrigger {
        super.parse(json);
        this.parseUnreadCounters(json);
        return this;
    }

    private parseUnreadCounters(json: RecursivePartial<VzParamOldTrigger>): void {
        VzParamOldTrigger.assignFields<VzParamOldTrigger>(this, json, [
            'type',
            'condition',
            'value',
        ]);
        VzParamOldTrigger.assignClassArrays<Omit<VzParamOldTrigger, 'value'>>(this, json, {
            actions: VzParamOldTriggerAction
        });
    }
}
